import { AddUsersToTeamRequest } from '@cbinsights/adminservice/adminservice';
import { request } from 'client/modules/common/utils/request';

export const addUserToTeam = (
  req: Partial<AddUsersToTeamRequest>
): Promise<void> =>
  request({
    url: '/service/adminservice/AddUsersToTeam',
    body: req,
  }).then((r) => r.body);
